/**
 * M1o2 Collection - Shop grid interactions (org convention: assets/<campaign>-<section>.js, IIFE, defer).
 * - Sort <details>: close on outside click / Escape, focus returns to the trigger.
 */
(function () {
	'use strict';

	function closeOpenSorts(except) {
		document.querySelectorAll('.m1o2-collection__sort[open]').forEach(function (details) {
			if (details === except) return;
			details.removeAttribute('open');
		});
	}

	function onDocumentClick(event) {
		document.querySelectorAll('.m1o2-collection__sort[open]').forEach(function (details) {
			if (!details.contains(event.target)) details.removeAttribute('open');
		});
	}

	function onDocumentKeydown(event) {
		if (event.key !== 'Escape') return;
		document.querySelectorAll('.m1o2-collection__sort[open]').forEach(function (details) {
			details.removeAttribute('open');
			var summary = details.querySelector('.m1o2-collection__sort-summary');
			if (summary) summary.focus();
		});
	}

	function onSortToggle(event) {
		var details = event.target;
		if (!details.matches || !details.matches('.m1o2-collection__sort')) return;
		if (details.open) closeOpenSorts(details);
	}

	document.addEventListener('click', onDocumentClick);
	/* ---- AJAX add-to-cart: stay on page, open the Dawn cart drawer. ----
	   The native {% form 'product' %} submit navigates to /cart (dropping
	   preview_theme_id) and renders Shopify's full error page on a 422 -
	   inside the theme editor that surfaces as "Something went wrong."
	   Mirrors m1o2-pdp-main.js wireAjaxAdd; errors show inline on the button. */
	function onFormSubmit(event) {
		var form = event.target.closest ? event.target.closest('.m1o2-collection__form') : null;
		if (!form) return;
		event.preventDefault();

		var btn = form.querySelector('[data-m1o2-cart-button]');
		var textEl = btn ? btn.querySelector('.m1o2-collection__cart-text') : null;
		var origHTML = textEl ? textEl.innerHTML : '';
		function restore() {
			if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
			if (textEl) { textEl.innerHTML = origHTML; }
		}
		if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
		if (textEl) { textEl.textContent = 'ADDING…'; }

		var drawer = document.querySelector('cart-drawer');
		var params = new URLSearchParams(new FormData(form));
		if (drawer && typeof drawer.renderContents === 'function') {
			params.append('sections', 'cart-drawer');
			params.append('sections_url', window.location.pathname);
		}
		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
			body: params.toString()
		}).then(function (r) { return r.json(); }).then(function (data) {
			if (data && data.status) { throw new Error(data.description || data.message || 'add failed'); }
			document.dispatchEvent(new CustomEvent('m1o2:cart:added'));
			if (drawer && data.sections && typeof drawer.renderContents === 'function') {
				// Adding to a previously-empty cart: clear is-empty so Dawn's open()/trapFocus
				// targets the populated #CartDrawer instead of the removed .drawer__inner-empty.
				drawer.classList.remove('is-empty');
				drawer.renderContents(data);
				restore();
			} else {
				if (textEl) { textEl.textContent = 'ADDED ✓'; }
				setTimeout(restore, 1400);
			}
		}).catch(function (err) {
			var msg = err && err.message ? String(err.message) : '';
			// Surface the storefront's verbatim rejection (diagnostic: names the exact
			// product/variant Shopify refused); generic fallback for network failures.
			if (textEl) { textEl.textContent = msg ? msg.toUpperCase().slice(0, 90) : 'COULD NOT ADD - TRY AGAIN'; }
			if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
			setTimeout(function () { if (textEl) { textEl.innerHTML = origHTML; } }, 5000);
			if (window.console) { console.error('m1o2 collection add failed', 'variant=' + (params.get('id') || '?'), err); }
		});
	}

	document.addEventListener('keydown', onDocumentKeydown);
	document.addEventListener('toggle', onSortToggle, true);
	document.addEventListener('submit', onFormSubmit);
})();
